<app-background urlNavigation="/login" (backEmitter)="onBack()">
  <div
    class="form-container"
    *ngIf="!registerSuccessfully && !completeRegister"
  >
    <form class="form" [formGroup]="registrationForm">
      <h1 class="form-title">Crie sua conta</h1>
      <div>
        <label for="email" class="field-validate__label"
          >Seu melhor e-mail</label
        >
        <div
          data-testid="email-input"
          class="input-wrapper outlined"
          [ngClass]="{
            'invalid-input':
              !this.registrationForm.get('email').valid &&
              this.registrationForm.get('email').touched
          }"
        >
          <input
            #email
            type="text"
            id="email"
            formControlName="email"
            (change)="setFormStorage('email')"
            [nextField]="password"
          />
        </div>
        <div style="height: 18px">
          <span
            *ngIf="
              !this.registrationForm.get('email').valid &&
              this.registrationForm.get('email').touched
            "
            class="span-error right"
          >
            E-mail inválido
          </span>
        </div>
      </div>
      <div class="pt-4">
        <label for="cpf" class="field-validate__label">CPF</label>
        <div
          data-testid="cpf-input"
          class="input-wrapper outlined"
          [ngClass]="{
            'invalid-input':
              !this.registrationForm.get('cpf').valid &&
              this.registrationForm.get('cpf').touched
          }"
        >
          <input
            #cpf
            type="text"
            id="cpf"
            formControlName="cpf"
            mask="000.000.000-00"
            placeholder="000.000.000-00"
            (change)="setFormStorage('cpf')"
            [nextField]="password"
          />
        </div>
        <div style="height: 18px">
          <span
            *ngIf="
              this.registrationForm.get('cpf').touched &&
              this.registrationForm.get('cpf').hasError('required')
            "
            class="span-error right"
          >
            Informe um CPF válido
          </span>
          <span
            *ngIf="
              this.registrationForm.get('cpf').touched &&
              !this.registrationForm.get('cpf').hasError('required') &&
              this.registrationForm.get('cpf').invalid
            "
            class="span-error right"
          >
            CPF inválido
          </span>
        </div>
      </div>
      <div class="pt-4">
        <label class="field-validate__label" for="password">Senha</label>
        <div
          data-testid="password-input"
          class="input-wrapper outlined position-relative"
          [ngClass]="{
            'invalid-input':
              !this.registrationForm.get('password').valid &&
              this.registrationForm.get('password').touched
          }"
        >
          <input
            #password
            [type]="showPassword ? 'text' : 'password'"
            id="password"
            formControlName="password"
            (input)="setFormStorage('password')"
          />
          <button class="button-password text-primary position-absolute fs-2">
            <i
              [class]="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"
              (click)="showPassword = !showPassword"
            ></i>
          </button>
        </div>
      </div>
      <div>
        <div style="height: 18px">
          <span
            *ngIf="
              !this.registrationForm.get('password').valid &&
              this.registrationForm.get('password').touched
            "
            class="span-error right"
          >
            Senha inválida
          </span>
        </div>
      </div>
      <div class="validator-container">
        <p class="validator">
          <i
            [class]="
              isMinLengthValid
                ? 'bi bi-check text-success'
                : 'bi bi-x text-danger'
            "
          ></i>
          Mínimo de 8 caracteres
        </p>
        <p class="validator">
          <i
            [class]="
              isUppercaseValid
                ? 'bi bi-check text-success'
                : 'bi bi-x text-danger'
            "
          ></i>
          Letra maiúscula
        </p>
        <p class="validator">
          <i
            [class]="
              isLowercaseValid
                ? 'bi bi-check text-success'
                : 'bi bi-x text-danger'
            "
          ></i>
          Letra minúscula
        </p>
        <p class="validator">
          <i
            [class]="
              isNumberValid ? 'bi bi-check text-success' : 'bi bi-x text-danger'
            "
          ></i>
          Número
        </p>
        <p class="validator">
          <i
            [class]="
              isSpecialCharValid
                ? 'bi bi-check text-success'
                : 'bi bi-x text-danger'
            "
          ></i>
          Caractere especial
        </p>
      </div>
      <div class="d-flex">
        <p class="termos">
          Criando uma conta você concorda com nossos
          <a [href]="termsPdfLink" target="_blank" rel="noopener noreferrer"
            >termos de uso e com nossas politicas de privacidade</a
          >
        </p>
      </div>
      <button
        data-testid="create-account-submit-button"
        class="btn-submit"
        (click)="onSubmit()"
      >
        Continuar
      </button>
      <div class="register-redirect">
        Já possui uma conta?
        <a
          [routerLink]="['/login']"
          [queryParams]="{ redirect: redirect?.fullEncoded }"
          >Acesse agora</a
        >
      </div>
    </form>
  </div>

  <section
    class="form-container"
    *ngIf="registerSuccessfully || completeRegister"
  >
    <app-confirm-email-message
      *ngIf="registerSuccessfully"
      [email]="registrationForm.controls['email'].value"
      type="register"
      [initiallyResent]="initialResent"
(tokenValidated)="onTokenValidated()"
    >
    </app-confirm-email-message>

    <app-registration-complete
      *ngIf="completeRegister"
      [email]="registrationForm.controls['email'].value"
      [redirect]="redirect"
      [ignoreCpf]="ignoreCpf"
    ></app-registration-complete>
  </section>
</app-background>
